import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';

import SelectCodeListItem from '../components/SelectCodeListItem';

import dsd from "../classes/clsDSD";

import { Plus, Trash } from 'react-bootstrap-icons';

class ParentItemRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);

        this.dsd = new dsd();
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
    }

    setup(){

        let StateChange = {
            FormData: {},
            Parent: null,
            seq: null,
            idCodeList: null,
            onAdd: null,
            onRemove: null,
            onUpdate: null,
        }

        StateChange.onAdd    = getParam('onAdd', this.props);
        StateChange.onRemove = getParam('onRemove', this.props);
        StateChange.onUpdate = getParam('onUpdate', this.props);

        StateChange.mode       = getParam('mode', this.props) || 'edit';
        StateChange.seq        = getParam('seq', this.props);
        StateChange.idCodeList = getParam('idCodeList', this.props);

        StateChange.Parent = getParam('Parent', this.props);
        if (isNull(StateChange.Parent)){
            StateChange.Parent = {};
        }

        StateChange.FormData = cloneObject(StateChange.Parent);

        this.setState(StateChange);
    }

    handleButton(event) {

        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnAdd':
                StateChange.mode = 'edit';
                if (this.state.onAdd){
                    this.state.onAdd();
                }
                break;
            case 'btnDelete':
                if (this.state.onRemove){
                    this.state.onRemove(this.state.seq);
                }
                break;
        }

        this.setState(StateChange);
        event.preventDefault();
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;
        this.setState({FormData: FormData});

        if (this.state.onUpdate){
            this.state.onUpdate(this.state.seq, FormData);
        }
    }

    render() {

        if (!this.state.FormData) {
            return null;
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':
                return (
                    <PD.Tr>
                        <PD.Td>
                            {(() => {
                                switch (this.state.mode) {
                                    case 'new':
                                        return <button name="btnAdd" onClick={this.handleButton}><Plus/></button>;
                                    case 'edit':
                                        return <button name="btnDelete" onClick={this.handleButton}><Trash/></button>;
                                }
                            })()}
                        </PD.Td>
                        {this.state.mode === 'edit' &&
                            <PD.Td>
                                <SelectCodeListItem
                                    label='Parent Item'
                                    name="idParent"
                                    onChange={this.handleChange}
                                    selectCodeList={false}
                                    idCodeList={this.state.idCodeList}
                                    value={this.state.FormData.idParent}
                                />
                            </PD.Td>
                        }
                    </PD.Tr>
                );
            default:
                return null;
        }
    }
}


export default function ParentItemRow_wrapper(props) {

    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ParentItemRow {...props} navigation={navigation} location={location} params={params} />;
}
